import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import SvgSMS from "./SvgSMS";
import SpinnerForBtn from "@/app/components/lib/loaders/SpinnerForBtn";

interface Props {
  isLoading?: boolean;
  children: string;
  onClick?: () => void;
}

const SMSCodeBtn: React.FC<Props> = ({
  isLoading = false,
  onClick,
  children,
}) => {
  return (
    <CustomButton
      type={BtnTypes.secondary}
      size={BtnSizes.large}
      radius={BtnRadius.small}
      fullWidth
      onClick={onClick}
    >
      <SvgSMS />
      {children}
      {isLoading && <SpinnerForBtn />}
    </CustomButton>
  );
};

export default SMSCodeBtn;
